import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Distributor.List.IRequest;
type Response = Api.Core.Distributor.List.IResponse;
type Headers = Api.Core.Distributor.List.IHeaders;
const url = '/api/Sales/Distributor';
export default async function distributorListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
